<template>
  <div :class="`course-form-control ${error ? 'course-form-control--error' : ''}`">
    <label v-show="label" >{{ label }}</label>
    <select v-bind="$attrs"
            @blur="$emit('blur', $event)"
            @change="$emit('input', $event.target.value)"
    >
      <option v-show="emptyOption" value="">{{emptyOptionLabel || ''}}</option>
      <option v-for="option in options" :value="option[valueKey || 'value']" :selected="String(option[valueKey || 'value']) === String(value)">{{option[labelKey || 'text']}}</option>
    </select>
    <span class="text-error" v-if="error">
      {{ error }}
    </span>
  </div>
</template>


<script>
export default {
  props: ['value', 'error', 'label', 'options',  'emptyOption', 'valueKey', 'labelKey', 'emptyOptionLabel'],
}
</script>